export const ORIGINS = {
  AOP: "Appellation d'Origine Protégée",
  BBC: "Bleu Blanc Coeur",
  BIO: "Bio",
  IGP: "Indication Géographique Protégée",
  LBR: "Label Rouge",
  POF: "Le Porc Français",
  FCS: "Viande Bovine Française",
};

export const PRODUCT_TYPES = {
  STARTER: "ENT",
  MAIN: "PLA",
  GRILL: "GRI",
  DESSERT: "DES",
  SIDE: "ACC",
  MENU: "MEN",
  TAKEAWAY: "TAK",
  COFFEE: "COF",
  SALAD: "SAL",
};

export const PRODUCT_TYPES_NAMES = {
  [PRODUCT_TYPES.STARTER]: "Entrée",
  [PRODUCT_TYPES.MAIN]: "Plat",
  [PRODUCT_TYPES.GRILL]: "Grillade",
  [PRODUCT_TYPES.DESSERT]: "Dessert",
  [PRODUCT_TYPES.MENU]: "Menu",
  [PRODUCT_TYPES.TAKEAWAY]: "Take Away",
  [PRODUCT_TYPES.COFFEE]: "Café",
  [PRODUCT_TYPES.SALAD]: "Salad'Bar/Dessert'Bar",
  [PRODUCT_TYPES.SIDE]: "Accompagnement"
};
